import { render, staticRenderFns } from "./box-shadow.vue?vue&type=template&id=07197b3f&"
import script from "./box-shadow.vue?vue&type=script&lang=js&"
export * from "./box-shadow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports